import { render, staticRenderFns } from "./PermissionsSelection.vue?vue&type=template&id=0bf653e8"
import script from "./PermissionsSelection.vue?vue&type=script&lang=js"
export * from "./PermissionsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports